// extracted by mini-css-extract-plugin
export default {"switchView":"styles_switchView__OZDNt","active":"styles_active__JDqyd"};